import { useRef } from "react";

export const usePageElements = () => {
  const baseElement = useRef<HTMLDivElement>(null);

  const getHeightForScroll = () => {
    //   alert(Array.from(document.querySelectorAll(".base-page-element") ?? []).length);
    const listOfBaseElements = Array.from(
      document.querySelectorAll(".base-page-element") ?? []
    );
    let globalHeight = 0;
    listOfBaseElements.forEach((el) => {
      globalHeight += el.clientHeight;
    });
    console.log(listOfBaseElements.map(el => el.clientHeight).join(","));
    return Math.floor(window.innerHeight - globalHeight);
  };
  return {
    baseElement,
    getHeightForScroll,
  };
};
